import { QuestionSearchPage } from './QuestionSearchPage';
export default QuestionSearchPage;
